import { PoSelectOption, PoTagType } from "@po-ui/ng-components";
import { InventoryStatusEnum } from "./enums/inventory-status.enum";

export const CONSTANTS = {
    ORDER_STATUS: {
        0: 'Status inválido',
        1: 'A separar',
        2: 'Separando',
        4: 'Atendido',
        5: 'Bloqueado'
    },
    ORDER_STATUS_COLORS: {
        0: PoTagType.Neutral,
        1: PoTagType.Info,
        2: PoTagType.Warning,
        4: PoTagType.Success,
        5: PoTagType.Danger
    },
    COUNT_STATUS: {
        0: 'Status inválido',
        1: 'Em Andamento',
        4: 'Atendida',
        5: 'Encerrada'
    },
    COUNT_STATUS_COLORS: {
        0: PoTagType.Neutral,
        1: PoTagType.Info,
        4: PoTagType.Warning,
        5: PoTagType.Success
    },
    QUANTITY_STATUS: {
        0: 'Status inválido',
        1: 'Qtd. original',
        2: 'Adicionado(s)',
        3: 'Removido(s)',
        4: 'Total de itens'
    },
    QUANTITY_STATUS_COLORS: {
        0: PoTagType.Neutral,
        1: PoTagType.Success,
        2: PoTagType.Info,
        3: PoTagType.Warning,
        4: PoTagType.Danger
    },
    INVENTORY_STATUS: {
        0: 'Status inválido',
        1: 'Em Andamento',
        5: 'Encerrada',
        6: 'Cancelada',
        10: 'Agrupada'
    },
    INVENTORY_HEADER_STATUS_COLORS: {
        0: PoTagType.Neutral,
        1: PoTagType.Info,
        5: PoTagType.Success,
        6: PoTagType.Danger,
        10: PoTagType.Warning
    },
    INVENTORY_HEADER_COUNT_STATUS: {
        0: 'Status inválido',
        1: 'Em Andamento',
        5: 'Encerrada',
        6: 'Cancelada',
        10: 'Agrupada'
    },
    INVENTORY_COUNT_STATUS_COLORS: {
        0: PoTagType.Neutral,
        1: PoTagType.Info,
        5: PoTagType.Success,
        6: PoTagType.Danger,
        10: PoTagType.Warning
    }
};


export const INVENTORY_STATUS: Array<PoSelectOption> = [
    { label: 'Em Andamento', value: InventoryStatusEnum.InProgress },
    { label: 'Calculada', value: InventoryStatusEnum.Calculated },
    { label: 'Contagem Iniciada', value: InventoryStatusEnum.CountingStarted }
];